import { Http } from "../core";
import appConfig from "@/config";
import { _get, _getNull, decrypt, encrypt, isObject, showToast, showToastAsync } from "@utils/utils";
import { getAccessToken, clearUserInfo, autoLogin, isLogin, isUserHandLoginOut, getOnlyId } from "@utils/user";
import { successLog } from "@/http/customLog";
import { router } from "@/router";
import { refreshPage } from "@utils/route";
import config from "@/config";
import { getAppClientConfig, isWxH5 } from "@utils/business";

// 为了解决循环引用
const _user = {
    getAccessToken: () => {
        return getAccessToken();
    },
    clearUserInfo: () => {
        return clearUserInfo();
    },
    autoLogin: () => {
        return autoLogin();
    },
    isLogin: () => {
        return isLogin();
    },
    refreshPage: () => {
        return refreshPage();
    },
    isUserHandLoginOut: () => {
        return isUserHandLoginOut();
    },
    getOnlyId: () => {
        return getOnlyId()
    }
};

let timer = null;

const http = Http({
    // 域名前缀
    prefixUrl: appConfig.modalApi.whApi,
    // 接口超时时间
    timeout: 5000,
    params: {
        t: () => {
            return +new Date()
        }
    },

    customLog: true,

    headers: {
        onlyId: () => {
            return _user.getOnlyId();
        },
        version: () => {
            if (isWxH5()) {
                return config.version;
            }
            return _get(getAppClientConfig('additionalHttpHeaders'), 'version', '')
        },

        bundleId: () => {
            return _get(getAppClientConfig('additionalHttpHeaders'), 'bundleId', '')
        },

        channel: () => {
            if (isWxH5()) return 'WH0009_mp'
            return _get(getAppClientConfig('additionalHttpHeaders'), 'channel', '')
        },

        deviceId: () => {
            return _get(getAppClientConfig('additionalHttpHeaders'), 'deviceId', '')
        },

        accesstoken: () => {
            return _user.getAccessToken()
        },
    },

    // 请求前拦截
    beforeRequest: (options) => {
        if (options.method === "post") {
            return { ...options, data: encrypt(JSON.stringify(options.data)) }
        }
        return options;
    },

    repeat: 2,

    success: async (_data, requestConfig) => {
        const data = JSON.parse(decrypt(_data));
        successLog(requestConfig, data)
        if ([201].includes(data.code) && _getNull(requestConfig, 'options.meta.login') && !_getNull(requestConfig, 'options.meta.unAutoLogin')) {
            _user.clearUserInfo();
            showToast('登录状态异常，重新登录中...')
            clearTimeout(timer)
            timer = setTimeout(async () => {
                // #ifdef H5
                router.navigateTo({ name: 'loginPhone' })
                return
                // #endif

                // 如果用户手动退出，直接跳转登录页
                if (_user.isUserHandLoginOut()) {
                    router.navigateTo({ name: 'login' })
                    return;
                }
                await _user.autoLogin()
                if (_user.isLogin()) {
                    _user.refreshPage()
                    return;
                }
                router.reLaunch({ name: 'home' })
            }, 1000)
        }

        if (isObject(data) && data.code === 200) {
            return { ...data, $code: 0, $success: true }
        }
        if (isObject(data)) {
            if (_getNull(requestConfig.options, 'meta.toast')) {
                await showToastAsync(_get(data, 'message', _get(requestConfig.options, 'meta.toastText', '网络繁忙，请稍后重试~')))
            }
            return { ...data, $code: -998, $success: false }
        }
    },
    fail: (res) => {
        if (isObject(res)) {
            res.$code = -999;
            res.$success = false;
            return res
        }
        return { $success: false, $code: -999, data: res }
    }
});

export default http
